import React from 'react';
import { ITagProps, Tag } from '../../npaper';
import { AgreementStatus, IAgreement } from '../../stores/AgreementStore';

export interface IAgreementStatusTagProps extends ITagProps {
  agreement: IAgreement;
}

export const AgreementStatusTag: React.FC<IAgreementStatusTagProps> = ({
  agreement,
  ...props
}) => (
  <Tag intent={agreement.statusIntent} {...props}>
    {agreement.status === AgreementStatus.DRAFT
      ? 'Kladde'
      : agreement.status === AgreementStatus.ACTIVE
      ? 'Aktiv'
      : agreement.status === AgreementStatus.CANCELLED
      ? 'Annulleret'
      : agreement.status === AgreementStatus.EXPIRED
      ? 'Udløbet'
      : 'Ups...'}
  </Tag>
);
